import React from 'react';
import { Anchor, Text } from 'grommet';

export const getLogAction = (event, companySlug) => {
    const eventType = event.type;
    const job = event.job ?? {};
    const jobUrl = companySlug
        ? `/${companySlug}/jobs/${job.id}`
        : `/jobs/${job.id}`;

    if (eventType == 'document_submitted') {
        const documentTypeTitle = event.document_type?.title;
        return `submitted their ${documentTypeTitle}`;
    }

    if (eventType == 'job_accepted_offer') {
        return (
            <Text>
                accepted their offer for the{' '}
                <Anchor label={job.title} href={jobUrl} /> position
            </Text>
        );
    }

    if (eventType == 'job_application_rejected') {
        return (
            <Text>
                &apos;s application was rejected for the{' '}
                <Anchor label={job.title} href={jobUrl} /> position
            </Text>
        );
    }

    if (eventType == 'job_applied') {
        return (
            <Text>
                applied to <Anchor label={job.title} href={jobUrl} />
            </Text>
        );
    }

    if (eventType == 'job_interested') {
        const jobLocations = event.candidacy?.job_locations;
        return (
            <Text>
                is interested in <Anchor label={job.title} href={jobUrl} />
                {jobLocations &&
                    ` at these locations: ${jobLocations.map((j) => j.location?.name ?? `${j.officeName || ''} ${j.mergeLocation || ''}`).join(', ')}`}
            </Text>
        );
    }

    if (eventType == 'job_matched') {
        return (
            <Text>
                was matched with the <Anchor label={job.title} href={jobUrl} />{' '}
                position
            </Text>
        );
    }

    if (eventType == 'job_missed_apply_deadline') {
        return (
            <Text>
                missed the application deadline{' '}
                <Anchor label={job.title} href={jobUrl} /> position
            </Text>
        );
    }

    if (eventType == 'job_missed_match_deadline') {
        return (
            <Text>
                missed the interest deadline for the{' '}
                <Anchor label={job.title} href={jobUrl} /> position
            </Text>
        );
    }

    if (eventType == 'job_not_interested') {
        return (
            <Text>
                said they weren&apos;t interested in the{' '}
                <Anchor label={job.title} href={jobUrl} /> position
            </Text>
        );
    }

    if (eventType == 'job_not_sure') {
        return (
            <Text>
                said they weren&apos;t sure about the{' '}
                <Anchor label={job.title} href={jobUrl} /> position
            </Text>
        );
    }

    if (eventType == 'job_received_assessment') {
        return (
            <Text>
                received an assessment for the{' '}
                <Anchor label={job.title} href={jobUrl} /> application process
            </Text>
        );
    }

    if (eventType == 'job_received_interview') {
        return (
            <Text>
                received an interview for the{' '}
                <Anchor label={job.title} href={jobUrl} /> position
            </Text>
        );
    }

    if (eventType == 'job_received_offer') {
        return (
            <Text>
                received an offer for the{' '}
                <Anchor label={job.title} href={jobUrl} /> position
            </Text>
        );
    }

    if (eventType == 'job_rejected_offer') {
        return (
            <Text>
                turned down their offer for the{' '}
                <Anchor label={job.title} href={jobUrl} /> position
            </Text>
        );
    }

    if (eventType == 'job_second_interview') {
        return (
            <Text>
                received another interview for the{' '}
                <Anchor label={job.title} href={jobUrl} /> position
            </Text>
        );
    }

    if (eventType == 'meeting_scheduled') {
        return 'scheduled a meeting';
    }

    if (eventType == 'job_auto_matched') {
        return (
            <Text>
                was auto-matched by system with the{' '}
                <Anchor label={job.title} href={jobUrl} /> position
            </Text>
        );
    }

    return `took an unknown action: ${eventType}`;
};
